<template>
  <form class='schedule-flow__viewing' data-vv-scope='flowViewing' id='plannerFrom' :action='route' method='POST'>
    <input type="hidden" name="property_id" :value="property.id">
    <input type="hidden" name="subscription_id" :value="subscription.id">
    <input type="hidden" name="appointment_id" :value="appointmentId">
    <h2 class='section-title'>{{locales.appointments && locales.appointments.schedule_viewing}}</h2>
    <div class='mb-10'>
      <div class="theme-table__heading">
        <h3 class="theme-table__title">{{locales.appointments && locales.appointments.guests_and_monthly_income}}</h3>
        <a :href='editRoute' class='theme-btn theme-btn--text'>
          {{ locales.common && locales.common.edit_your_profile }}
          <i class='icon-go-right'/>
        </a>
      </div>
      <div class='theme-table__wrap mb-5' v-if="subscription && subscription.tenants">
        <table class='theme-table'>
          <tbody>
            <tr v-for='(user, index) in subscription.tenants' :key='index'>
              <td>{{ user.fullNameWithTitle }}</td>
              <td>€ {{ user.income }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class='theme-alert theme-alert--info'>
        <div class='theme-alert__icon'><i class='icon-notice'/></div>
        <div class='theme-alert__text'>{{locales.appointments && locales.appointments.you_need_prove_income}}
        </div>
      </div>
    </div>
    <div class='grid grid-cols-1 md:grid-cols-2 gap-4 mb-9'>
      <functional-calendar
        :configs='calendarConfigs'
        v-model='date'
        class='single-calendar'
        @choseDay='handleDateChange'
      >
        <template v-slot:datePickerInput='props'>
          <theme-input
            :label='locales.appointments && locales.appointments.choose_date'
            :placeholder='locales.common && locales.common.choose_date'
            :value='dateComputed'
            name='date'
            v-validate='`required`'
            valid-scope='flowViewing'
            :isExtraInfo='true'
            :isReadonly='true'
          >
            <template slot='extra-info'>
              <i class='icon-calendar'/>
            </template>
          </theme-input>
        </template>
      </functional-calendar>
      <theme-select
        :label='locales.appointments && locales.appointments.choose_time'
        :placeholder='locales.common && locales.common.choose_time'
        :disabled='!dateComputed'
        name='time'
        v-validate='`required`'
        valid-scope='flowViewing'
        :value='time'
        :options='timeOptions'
        :isExtraInfo='true'
        @change='handleTimeChange'
      >
        <template slot='extra-info'>
          <i class='icon-time'/>
        </template>
      </theme-select>
    </div>
    <div class='flex flex-col lg:flex-row gap-4 items-start lg:items-center'>
      <a href='#' class='theme-btn theme-btn--theme' :class="{'theme-btn--theme-disabled': !dateComputed || !time}" @click.prevent='submit'>{{locales.common && locales.common.continue}}</a>
      <div class='theme-alert theme-alert--notice'>
        <div class='theme-alert__icon'><i class='icon-notice'/></div>
        <div class='theme-alert__text'>{{locales.appointments && locales.appointments.you_will_be_notified}}
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import {FunctionalCalendar} from 'vue-functional-calendar';
  import $ from 'jquery';
  import sweetalert from 'sweetalert';
  import { mapGetters } from 'vuex'

  export default {
    $_veeValidate: {
      validator: 'new',
    },
    props: {
      property: {
        default: () => {},
        type: Object,
      },
      subscription: {
        default: () => {},
        type: Object,
      },
      agendaRoute: {
        default: '',
        type: String,
      },
      route: {
        default: '',
        type: String,
      },
      editRoute: {
        default: "",
        type: String
      },
      excludedDays: {
        default: [],
        type: Array,
      },
      excludedDates: {
        default: [],
        type: Array,
      },
    },
    components: {FunctionalCalendar},
    data() {
      return {
        validated: false,
        calendarConfigs: {
          dateFormat: 'dd-mm-yyyy',
          limits: {
            min: moment().format('DD-MM-YYYY'),
            max: moment().add('10', 'y').format('DD-MM-YYYY'),
          },
          disabledDayNames: this.excludedDays,
          disabledDates: this.excludedDates,
          isModal: true,
          isDatePicker: true,
          isAutoCloseable: true,
        },
      };
    },
    computed: {
      ...mapGetters(['locales']),
      dateComputed() {
        return this.date && this.date.selectedDate ? this.date.selectedDate : '';
      },
      appointmentId: function() {
        return this.$store.getters.getAppointmentId;
      },
      date: {
        get() {
          return JSON.parse(JSON.stringify(this.$store.getters.getScheduleDate));
        },
        set(newValue) {
          this.$store.commit('CHANGE_SCHEDULE_DATE', JSON.parse(JSON.stringify(newValue)));
        },
      },
      time() {
        return this.$store.getters.getScheduleTime;
      },
      timeOptions() {
        return this.$store.getters.getScheduleTimeOptions;
      },
    },
    methods: {
      submit() {
        this.$validator.validateAll('flowViewing').then((valid) => {
          this.validated = true;
          if (valid) {
            let postData = $('#plannerFrom').serializeArray();
            let action = $('#plannerFrom').attr('action');
            $.ajax({
              url: action,
              type: 'POST',
              data: postData,
              cache: false,
              success: (data) => {
                this.$store.commit('CHANGE_SCHEDULE_STEP', 2);
                this.$store.commit('APPOINTMENT_ID', data.id);
              },
              error: (e) => {
                if (e.status == 403) {
                  sweetalert(window.app.locales.common.error, window.app.locales.common.login_required, 'error');
                } else {
                  sweetalert(window.app.locales.common.error, window.app.locales.appointments.planner_error, 'error');
                }
              },
            });
          }
        });
      },
      checkAvailableTimes() {
        if (this.dateComputed) {
          window.axios.post(this.agendaRoute, {
            date: this.dateComputed,
            propertyId: this.property.id,
          })
            .then(response => {
              if (response.data !== undefined && response.data !== '') {
                this.$store.commit('CHANGE_SCHEDULE_TIME_OPTIONS', response.data);
              } else {
                this.$store.commit('CHANGE_SCHEDULE_TIME_OPTIONS', {});
              }
            });
        }
      },
      handleDateChange() {
        this.$store.commit('CHANGE_SCHEDULE_TIME', '');
        this.checkAvailableTimes();
      },
      handleTimeChange(time) {
        this.$store.commit('CHANGE_SCHEDULE_TIME', time);
      },
    },
  };
</script>


// WEBPACK FOOTER //
// resources/js/components/ScheduleFlowViewing.vue